/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import Icon from 'components/Icon';
import { GRAY } from 'styles/colors';
import { MEDIA_QUERIES } from 'styles/constants';
import { ReactComponent as ClockIcon } from 'assets/icons/Clock.svg';
import { ReactComponent as CalendarIcon } from 'assets/icons/Calendar.svg';

const cardStyles = css`
  background: #fff;
  border-radius: 25px;
  border: 1px solid #c5bcfe;
  box-shadow: 0 20px 60px 0 rgba(197, 188, 254, 0.2);
  padding: 44px;
  display: flex;
  flex-direction: column;
  width: 365px;
  height: 240px;
  flex: 0 0 365px;
  margin: 15px;
  box-sizing: border-box;

  ${MEDIA_QUERIES.smallScreen} {
    width: 300px;
    flex: 0 0 300px;
    height: auto;
  }

  ${MEDIA_QUERIES.tablet} {
    width: 280px;
    flex: 0 0 280px;
    height: auto;
    margin: 10px;
  }

  ${MEDIA_QUERIES.mobile} {
    width: 100%;
    height: auto;
    flex: 0 0 100%;
    margin: 8px 0;
  }

  .addon-category {
    color: #5956f2;
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin-bottom: 10px;
  }

  .addon-name {
    color: #313033;
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert, sans-serif;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    margin: 0 0 10px;
  }

  .addon-description {
    color: #313033;
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    flex: 1;
    margin: 0;
  }

  .addon-label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 600;
    color: ${GRAY};
    margin-top: 8px;
  }
`;

function AddonCard({ category, name, description, duration, days }) {
  return (
    <div css={cardStyles}>
      <span className="addon-category">{category}</span>
      <p className="addon-name">{name}</p>
      <p className="addon-description">{description}</p>
      {duration && (
        <span className="addon-label">
          <Icon icon={ClockIcon} color={GRAY} size={12} />
          {duration}
        </span>
      )}
      {days && (
        <span className="addon-label">
          <Icon icon={CalendarIcon} color={GRAY} size={12} />
          {days}
        </span>
      )}
    </div>
  );
}

AddonCard.propTypes = {
  category: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  duration: PropTypes.string,
  days: PropTypes.string,
};

AddonCard.defaultProps = {
  duration: null,
  days: null,
};

export default AddonCard;
